import { lazy, Suspense, useEffect, useState } from 'react'
import {
  ControlOutlined,
  ProfileOutlined,
  TableOutlined,
} from '@ant-design/icons'
import Col from 'antd/es/grid/col'
import Row from 'antd/es/grid/row'
import Segmented from 'antd/es/segmented/index'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '@/redux/hooks.ts'
import {
  selectIdeaListInput,
  setMobileView,
} from '@/redux/slices/idea-list-input.slice.ts'
import { NEW_RELIC, newRelic } from '@/utils/new-relic.ts'
import { IdeyaButton } from '@/common/antd/ideya-button/ideya-button.tsx'

// Only rendered below the md breakpoint, so desktop never downloads the popup.
const loadViewConfigPopup = () => import('./idea-list-view-config-popup.tsx')
const IdeaListViewConfigPopup = lazy(() =>
  loadViewConfigPopup().then((m) => ({ default: m.IdeaListViewConfigPopup }))
)

export const IdeaListUserFilterControlsMobile: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const ideaListInput = useAppSelector(selectIdeaListInput)
  const [viewConfigOpen, setViewConfigOpen] = useState(false)

  useEffect(() => {
    void loadViewConfigPopup()
  }, [])

  return (
    <Col flex={1}>
      <Row
        justify={ideaListInput.mobileView === 'card' ? 'space-between' : 'end'}
        align={'middle'}
      >
        {ideaListInput.mobileView === 'card' && (
          <Col>
            <IdeyaButton
              ideyaType={'bw'}
              icon={<ControlOutlined />}
              onClick={() => setViewConfigOpen(true)}
            >
              {t('idea_list.view_config.title')}
            </IdeyaButton>
            <Suspense fallback={null}>
              <IdeaListViewConfigPopup
                open={viewConfigOpen}
                onClose={() => setViewConfigOpen(false)}
              />
            </Suspense>
          </Col>
        )}
        <Col>
          <Segmented
            value={ideaListInput.mobileView}
            onChange={(value) => {
              const previousView = ideaListInput.mobileView
              if (value !== previousView) {
                newRelic.recordCustomEvent(
                  NEW_RELIC.CUSTOM_EVENT.ideaListMobileViewChanged,
                  {
                    view: value,
                    previousView,
                    trigger: 'user-toggle',
                  }
                )
              }
              dispatch(setMobileView(value))
            }}
            options={[
              {
                value: 'table',
                label: <TableOutlined />,
              },
              {
                value: 'card',
                label: <ProfileOutlined />,
              },
            ]}
          />
        </Col>
      </Row>
    </Col>
  )
}
